"use client";

import { buildSearchFacetBreadcrumbs, type SearchFacet } from "@/lib/search-facet-breadcrumbs";

interface SearchFacetBreadcrumbsProps {
  facets: SearchFacet[];
  title?: string;
}

export function SearchFacetBreadcrumbs({
  facets,
  title = "Agent filters",
}: SearchFacetBreadcrumbsProps) {
  const chips = buildSearchFacetBreadcrumbs(facets);
  if (chips.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-gray-200 bg-white px-3 py-3 text-sm shadow-sm">
      <div className="text-xs font-medium text-ink-secondary">{title}</div>
      <div className="flex flex-wrap items-center gap-2">
        {chips.map((chip) => (
          <span
            key={chip.id}
            className="inline-flex h-6 max-w-56 items-center gap-1 rounded-full border border-gray-200 bg-gray-50 px-2 text-xs font-medium text-ink"
            title={`${chip.groupLabel}: ${chip.label}`}
          >
            <span className="truncate">
              <span className="text-ink-secondary">{chip.groupLabel}:</span> {chip.label}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
